import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
const RiderInvoiceForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`w-64`}>
      <ComboboxInput
        url={APIS.RIDER}
        queryKey={"rider"}
        register={register("vendor", {
          required: "Rider Name is required",
        })}
        errors={errors?.vendor}
        name={"vendor"}
        label={"Select Rider"}
        setValue={setValue}
        placeholder={"Select Rider"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
    </div>
  );
};

export default RiderInvoiceForm;
